import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import dev404 from '../img/assets/dev_404.png';
import { LanguageContext } from '../contexts/LanguageContext';
import '../styles/404.css';

const NotFoundPage: React.FC = () => {
    const { language } = useContext(LanguageContext)!;

    return (
        <div className="not-found-container">
            <h1>{language === 'fr' ? "La page que vous cherchez n'existe pas." : "The page you are looking for does not exist."}</h1>
            <Link to="/" className="back-home-btn">{language === 'fr' ? "Retour à l'accueil" : "Back to home page"}</Link>
            <img src={dev404} alt="Page 404 - Développeur endormi" className="not-found-image" loading="lazy" />
        </div>
    );
};

export default NotFoundPage;
